var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "account_balance"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_165_61035",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.666626,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_165_61035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "account_balance_2",
    d: "M7.16663 17V8.99998H8.16663V17H7.16663ZM12.1666 17V8.99998H13.1666V17H12.1666ZM4.20508 20V19H21.1282V20H4.20508ZM17.1666 17V8.99998H18.1666V17H17.1666ZM4.20508 6.99998V6.15383L12.6666 2.11536L21.1282 6.15383V6.99998H4.20508ZM6.8474 5.99998H18.4859L12.6666 3.24998L6.8474 5.99998Z",
    fill: "#15B79E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIcon);
export default __webpack_public_path__ + "static/media/bank-icon.2b96d508db2491ec09d6ff4b206c0bf1.svg";
export { ForwardRef as ReactComponent };